import { render, staticRenderFns } from "./add-rule.vue?vue&type=template&id=4b53097c"
import script from "./add-rule.vue?vue&type=script&lang=js"
export * from "./add-rule.vue?vue&type=script&lang=js"
import style0 from "./add-rule.vue?vue&type=style&index=0&id=4b53097c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports